import React from 'react';

interface ChevronDownIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({
  className = '',
  style = {}
}) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
        ...style
      }}
    >
      <path
        d="M5.78758 9.55821C5.85906 9.57315 5.9285 9.59864 6.00116 9.59864C6.07382 9.59864 6.14325 9.57315 6.21473 9.55821C6.27508 9.54561 6.33719 9.54561 6.39491 9.52218C6.46464 9.49405 6.52294 9.44043 6.58622 9.39679C6.6369 9.36193 6.69418 9.34112 6.73944 9.2963C6.74091 9.29484 6.7412 9.29278 6.74267 9.29132C6.74415 9.28986 6.74619 9.28957 6.74765 9.28809L11.6379 4.33809C12.0457 3.92559 12.0422 3.26114 11.6297 2.85333C11.2172 2.44552 10.5515 2.44904 10.1449 2.86154L6.00117 7.05597L1.85742 2.86154C1.45078 2.44904 0.785164 2.44552 0.372663 2.85333C0.165244 3.05841 0.0609398 3.32911 0.0609398 3.59982C0.0609398 3.86583 0.161715 4.13302 0.364455 4.33809L5.2547 9.28809C5.25616 9.28956 5.25821 9.28984 5.25968 9.29132C5.26114 9.2928 5.26143 9.29484 5.2629 9.2963C5.30817 9.34112 5.36544 9.36193 5.41613 9.39679C5.47941 9.44044 5.53772 9.49405 5.60744 9.52218C5.66516 9.54561 5.72722 9.54561 5.78758 9.55821Z"
        fill="#999999"
      />
    </svg>
  );
};

export default ChevronDownIcon;
